import React, { useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import { useSelector } from "react-redux";
import CustomUserIcon from "../../../../app/assets/custom-icons/CustomUserIcon";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import ListsNotification from "./ListsNotification";
import { Badge, IconButton, styled, Menu } from "@mui/material";
import ListsSettings from "./ListsSettings";
import { useNavigate } from "react-router-dom";

const CustomToolbar = ({ routes }) => {
  const navigate = useNavigate();
  const studioName = useSelector((state) => state.app.studioName);
  const role = useSelector((state) => state.app.role);
  const userEmail = useSelector((state) => state.app.userEmail);
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const notifications = useSelector((state) => state.app.notifications);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElNotifiche, setAnchorElNotifiche] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      border: `2px solid white`,
      padding: "5px",
    },
  }));

  return (
    <Toolbar className="bg-white shadow-none flex justify-end items-center h-[72px]">
      <div className="flex items-center">
        <IconButton onClick={() => navigate("assistenza")}>
          <HelpRoundedIcon style={{ color: `${primaryColor}` }} />
        </IconButton>

        <StyledBadge
          badgeContent={
            notifications.filter((notifica) => notifica?.read !== true).length
          }
          invisible={notifications.length > 0 ? false : true}
          color="error"
          className="bottom-2 left-8 "
        />
        <IconButton onClick={(e) => setAnchorElNotifiche(e.currentTarget)}>
          <NotificationsRoundedIcon
            style={{
              color: `${primaryColor}`,
            }}
          />
        </IconButton>
        <Menu
          anchorEl={anchorElNotifiche}
          open={Boolean(anchorElNotifiche)}
          onClose={() => setAnchorElNotifiche(null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <ListsNotification
            lists={notifications}
            setAnchorElNotifiche={setAnchorElNotifiche}
          />
        </Menu>
      </div>

      <div className="border-r border-white h-6 mx-4"></div>
      <div className="flex flex-row items-center space-x-4">
        <div className="text-black font-bold">
          {role === "User" ? userEmail : studioName ? studioName : userEmail}
        </div>
        <div className="">
          <button
            onClick={handleMenuOpen}
            className=" ring-inset border-none bg-white cursor-pointer text-white"
          >
            <CustomUserIcon className="w-11 h-11" />
          </button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <ListsSettings routes={routes} />
          </Menu>
        </div>
      </div>
    </Toolbar>
  );
};

export default CustomToolbar;
